export const state = {
  words: [],
  pagination: null,
  isLoading: false
};
